import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { NotFoundItem } from './NotFoundItem'

export interface NotFoundWithButtonsProps {
  mainTitle?: string
}
export class NotFoundWithButtonsInner extends React.Component<
  NotFoundWithButtonsProps & RouteComponentProps<{}>,
  {}
> {
  render() {
    const { mainTitle, children, history, ...others } = this.props
    return (
      <NotFoundItem mainTitle={mainTitle} {...others}>
        <button onClick={history.goBack}>Wróć</button>

        {children}
      </NotFoundItem>
    )
  }
}

export const NotFoundWithButtons = withRouter(NotFoundWithButtonsInner)
